// extracted by mini-css-extract-plugin
export default {"followButton":"FollowButton-module__followButton___3i9RP","followButtonWhite":"FollowButton-module__followButtonWhite___2ugf-"};